import 'dayjs/locale/es'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'

import { Ticket } from '@types'

import { BoardColumn, BoardHeader, BoardContent } from '..'
import RequestCard from './components/RequestCard'

interface RequestsBoardProps {
  tickets: Ticket[] | undefined
  day: string | undefined
}

dayjs.locale('es')

const RequestsBoard = (props: RequestsBoardProps) => {
  const { tickets } = props
  const { Text } = Typography
  const { day } = props
  const { t } = useTranslation()

  return (
    <BoardColumn>
      <BoardHeader>
        <Text className="board-header-title">{day}</Text>
        {tickets && tickets.length > 0 && (
          <Text className="board-header-quantity">
            {`${tickets?.length} ${
              tickets.length > 1 ? t('globals.generics.requests') : t('globals.generics.request')
            }`}
          </Text>
        )}
      </BoardHeader>
      <BoardContent>
        {tickets && tickets.map((ticket: Ticket) => <RequestCard key={ticket.id} data={ticket} />)}
      </BoardContent>
    </BoardColumn>
  )
}

export default RequestsBoard

//TODO: Tablero de solicitudes
